module.exports = __webpack_public_path__ + "static/notification-groups-list-2-b46a917667982af4b6cb65582a5d7376.png";